module.exports = __webpack_public_path__ + "static/media/buromobelexperte.0ee97c20.svg";